<template>
  <div class="shareApp">
<!--    <h1>动态ID:{{dailyId}}</h1>-->
    <keep-alive :exclude="['Lobby', 'FreeCourse', 'PlanList',]">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import {app} from "../network/app/app";
import {enableAppSDK, getWXLogin} from "../network/wx/wxmp";
import {Dialog} from "vant";
const wxRetState = 'ie8dflfLfiwq'
export default {
  name: 'ShareApp',
  data(){
    return {
      //获取单条动态ID
      dailyId: '',
    }
  },
  destroyed() {
    console.log('destroyed shareApp');
  },
  created() {
    app.disable()

    // console.log('shareApp create');
    // //输入的参数
    // console.log(this.$route.params)
    // console.log(this.$route.query)

    this.dailyId = this.$route.params.dailyId

  },
}
</script>

<style scoped>
.shareApp {
  width: 100%;
  height: 100%;
}
</style>
